<template>
  <div>
    <b-modal
      v-if="detailsFile"
      :id="`modal-action-${action}`"
      :ref="`modal-action-${action}`"
      :title="`${title} documento`"
      :ok-title="title"
      cancel-title="Cancelar"
      no-close-on-backdrop
      @ok="commitAction"
      @cancel="cancelProcess"
      size="lg"
      centered
    >
      <b-overlay :show="loading">
        <div v-if="!confirmed" class="my-5">
          <p class="warning-confirmation">
            Antes de
            <span v-if="processDocument === 'foliar'">
              numerar
            </span>
            <span v-if="processDocument === 'tramitar'">
              {{ processDocument }}
            </span>
            este documento por favor <b>asegúrate de
            que la lista de destinatarios es la correcta</b> y además queremos que
            sepas que <b>vas a gestionar este documento para la oficina</b>
            <b>
              {{ stepId.temporalAutorUsuarioNombre }}
            </b>
            <br>
            (para revisar los destinatarios, haz click sobre el botón que se ve
            en la parte inferior izquierda que se ve así
            <b-button
              variant="outline-info"
              class="btn-icon rounded-circle shadow-lg mx-3 bg-white"
            >
              <feather-icon icon="UsersIcon"/>
            </b-button>
            )
          </p>
          <div class="text-right">
            <b-button variant="outline-warning" @click="confirmManagement" size="sm">
              Esta bien, confirmo!
            </b-button>
          </div>
          <div v-if="noAction" class="text-danger text-center mt-4">
            <b>
              Por favor, confirma e ingresa la información requerida para poder
              <span v-if="processDocument === 'foliar'">
                numerar
              </span>
              <span v-if="processDocument === 'tramitar'">
                {{ processDocument }}
              </span>
              el documento
            </b>
          </div>
        </div>
        <div class="-mt-2" v-if="confirmed">
          <div v-if="process" class="mb-2">
            <div class="warning-confirmation my-2 text-center" v-if="noNumeration">
              Hey! Este documento no esta disponible para numeración
            </div>
            <div class="d-flex justify-content-around">
              <b-form-radio
                v-if="processDocument === 'foliar'"
                v-model="processDocument"
                plain
                name="some-radios3"
                value="foliar"
                @change="setManagementType"
              >
                Numerar
              </b-form-radio>
              <b-form-radio
                v-if="processDocument === 'tramitar'"
                v-model="processDocument"
                plain
                name="some-radios4"
                value="tramitar"
                @change="setManagementType"
              >
                Tramitar
              </b-form-radio>
            </div>
          </div>
          <form
            data-vv-scope="sign-document"
            class="mt-4"
          >
            <div class="row">
              <div class="col-6 mt-3">
                <label>Fecha</label>
                <b-form-datepicker
                  :min="min"
                  id="example-datepicker"
                  v-model="manageDate"
                  class="w-100"
                  label-help="Puede usar las flechas del teclado y espacio"
                />
              </div>
              <div class="col-6 mt-3">
                <vs-select
                  autocomplete
                  class="w-100 con-select autocompletex"
                  label="Seleccione tipo de Firma"
                  v-model="signType"
                >
                  <vs-select-item
                    :value="firma"
                    :text="providerName(firma.proveedor)"
                    v-for="firma in userSignConfiguration.userSigns"
                    :key="firma.id"
                  />
                </vs-select>
              </div>
              <div class="col-6 mt-3">
                <vs-input
                  v-if="signerProviderConfig.otp"
                  type="number"
                  class="w-100"
                  label="Código OTP"
                  maxlength="6"
                  name="otp"
                  v-model="otpCode"
                  v-validate="'required'"
                  :danger="errors.has('sign-document.otp')"
                  :danger-text="errors.first('sign-document.otp')"
                />
              </div>
            </div>
          </form>
        </div>
      </b-overlay>
    </b-modal>
    <b-modal
      title-class="font-weight-bold text-success"
      centered
      size="sm"
      no-close-on-backdrop
      title="Genial!"
      ref="numerateModal"
      id="numerateModal"
      hide-header-close
    >
      <h5 v-if="processDocument === 'foliar'">
        Se ha numerado el documento con el <b>número #{{ folio }}</b>
      </h5>
      <h5 v-else>Se ha tramitado el documento exitosamente</h5>
      <template #modal-footer="{ ok }">
        <div class="w-100">
          <b-button
            variant="success"
            class="float-right"
            @click="ok($router.back())"
          >
            Ok
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      :id="`modal-action-office-agile`"
      :ref="`modal-action-office-agile`"
      :title="`${title} documento`"
      :ok-title="title"
      no-close-on-backdrop
      cancel-title="Cancelar"
      @ok="commitActionAgile"
      @cancel="cancelProcess"
      size="sm"
    >
      <b-overlay :show="loading">
        <form
        autocomplete="off"
        data-vv-scope="sign-document-agile"
        class="d-flex justify-content-center"
        v-on:submit.prevent
      >
        <div class="container">
          <div class="row">
            <div class="col-12">
              <p>
                Se ha enviado un código de seguridad a tu dirección de correo electrónico.
                Por favor, revisa tu bandeja de entrada.
                El correo contendrá un código de seguridad único
                que deberás ingresar para completar el proceso de registro.
              </p>
              <p>
                Si no encuentras el correo electrónico en tu bandeja de entrada,
                te recomendamos verificar la carpeta de correo no deseado (spam).
              </p>
              <p>
                Recuerda que el código de seguridad es personal y confidencial.
                No lo compartas con nadie y asegúrate de ingresarlo correctamente.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <input
                  placeholder="Ingresar código que se envió a su correo"
                  class="form-control"
                  v-model="otpCode"
                  v-validate="'required'"
                >
              </div>
            </div>
          </div>
        </div>
      </form>
      </b-overlay>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import {
  VBToggle,
  BModal,
  VBModal
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import { uuid } from 'vue-uuid';

import {
  signerProviderConfigs
} from '@/febos/chile/approvals/components/trays/managementTray/constants';

export default {
  components: {
    BModal
  },
  data() {
    return {
      loading: false,
      min: this.$moment().subtract(5, 'days').format('YYYY-MM-DD'),
      error: {
        message: ''
      },
      otpCode: '',
      signType: '',
      numeration: '',
      manageDate: this.$moment().format('YYYY-MM-DD'),
      confirmed: false,
      noAction: false,
      folio: '',
      actionType: '',
      signerProviderConfigs,
      signerProviderConfig: {},
      metadata: {}
    };
  },
  computed: {
    ...mapGetters('Management', [
      'allDocuments'
    ]),
    ...mapGetters('Empresas', [
      'userSignConfiguration'
    ]),
    ...mapGetters('Dnts', [
      'detailsFile'
    ]),
    ...mapGetters('Approvals', [
      'loadingNumeration',
      'fileOnFlow'
    ]),
    providerName() {
      return (provider) => this.signerProviderConfigs[provider]?.description || provider;
    },
    noNumeration() {
      if (this.fileOnFlow?.detalle?.ejecucion?.tipoReferencia !== 'ARCHIVO') {
        return this.detailsFile.dnt.emisorSucursalCodigo === ''
          || !this.detailsFile.dnt.emisorSucursalCodigo;
      } else {
        return !this.fileOnFlow?.detalle?.ejecucion?.tipoDocumentoId
          || this.fileOnFlow?.detalle?.ejecucion?.tipoDocumentoId === '';
      }
    },
    typeNumeration() {
      if (this.fileOnFlow.detalle.ejecucion.tipoObjetoCategoria === 'respuesta'
        || this.fileOnFlow.detalle.ejecucion.tipoReferencia === 'ARCHIVO') {
        const typeDocument = this.fileOnFlow.detalle.ejecucion.tipoDocumentoId || '';
        console.log('typ', typeDocument, this.allDocuments)
        return this.allDocuments.find((doc) => doc.id === typeDocument).id;
      }
      if (this.detailsFile.dnt.emisorSucursalCodigo) {
        const typeDocument = this.detailsFile.dnt.emisorSucursalCodigo || '';
        return this.allDocuments.find((doc) => doc.value === typeDocument).id;
      }
      return '';
    },
    processDocument() {
      let isNumeration = false;
      if (this.fileOnFlow.meta) {
        isNumeration = Object.keys(this.fileOnFlow.meta.oficinaAcciones).includes('foliar');
      } else {
        isNumeration = true;
      }
      return isNumeration ? 'foliar' : 'tramitar';
    }
  },
  watch: {
    signType(sign) {
      this.$emit('selectedSign', sign);
      this.configActiveSigner();
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'processFileFlow',
      'manageFileFlow',
      'setProcessDocument'
    ]),
    confirmManagement() {
      this.confirmed = true;
    },
    setManagementType() {
      this.setProcessDocument(this.processDocument);
    },
    cancelProcess() {
      this.confirmed = false;
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async signDocument() {
      const isValid = await this.validateForm('sign-document');
      if (!isValid) {
        return;
      }
      const sign = this.getSign();
      if (!(sign.y >= 0 && sign.x >= 0)) {
        this.$bvToast.toast(
          'No has colocado la ubicación de la estampa',
          {
            title: '¡Oops!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }

      if (!this.confirmed) {
        this.noAction = true;
        return;
      }

      this.loading = true;
      const body = {
        folio: this.numeration,
        pasoId: this.stepId.id,
        ejecucionId: this.$route.params.flowId,
        aprobacionId: this.$route.params.fileId,
        documentoId: uuid.v1(),
        codigoAutenticador: this.otpCode,
        password: 'na',
        tipoFirma: this.signType.tipo,
        idDigitalFirma: this.signType.id,
        OTP: this.otpCode,
        paginaFirma: sign.page,
        // eslint-disable-next-line radix
        coordenadaY: Math.floor(sign.y),
        coordenadaX: Math.floor(sign.x),
        cordenadasAlto: sign.height,
        cordenadasAncho: sign.width
      };
      if (this.signType.proveedor === signerProviderConfigs.FirmadorMinisterioEconomia.key) {
        delete body.coordenadaY;
        delete body.coordenadaX;
        delete body.paginaFirma;
      }
      if (this.signType.proveedor === signerProviderConfigs.SAgile.key) {
        body.noRedirectOnEnd = true;
      }
      const meta = {
        fecha: this.manageDate,
        accion: this.processDocument,
        alcanceId: this.stepId.temporalAutorUsuarioId
          || this.stepId.paso.tipoValorResponsableId
      };

      if (this.processDocument === 'foliar') {
        meta.tipoDocId = this.typeNumeration;
        meta.alcanceId = this.stepId.temporalAutorUsuarioId
          || this.stepId.paso.tipoValorResponsableId;
      }

      try {
        const response = await this.manageFileFlow({ body, meta });
        this.loading = false;
        if (this.signType.proveedor === signerProviderConfigs.SAgile.key) {
          this.otpCode = '';
          this.$refs['modal-action-office-agile'].show();
          this.meta.challegeId = response.meta.challegeId;
          this.meta.transaccionId = response.meta.transaccionId;
          this.meta.validacionCode = response.meta.transaccionId;
        } else {
          if (this.processDocument === 'foliar') {
            this.folio = response.meta.folio;
          }
          this.$refs.numerateModal.show();
        }
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
    commitAction(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.signDocument();
    },
    commitActionAgile(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.signDocumentAgile();
    },
    async signDocumentAgile() {
      const isValid = await this.validateForm('sign-document-agile');
      if (!isValid) {
        return;
      }
      const sign = this.getSign();
      this.loading = true;
      const body = {
        folio: this.numeration,
        pasoId: this.stepId.id,
        ejecucionId: this.$route.params.flowId,
        aprobacionId: this.$route.params.fileId,
        documentoId: uuid.v1(),
        codigoAutenticador: this.otpCode,
        password: 'na',
        tipoFirma: this.signType.tipo,
        idDigitalFirma: this.signType.id,
        OTP: this.otpCode,
        paginaFirma: sign.page,
        // eslint-disable-next-line radix
        coordenadaY: parseInt(sign.y),
        coordenadaX: sign.x,
        cordenadasAlto: sign.height,
        cordenadasAncho: sign.width
      };
      if (this.signType.proveedor === signerProviderConfigs.FirmadorMinisterioEconomia.key) {
        delete body.coordenadaY;
        delete body.coordenadaX;
        delete body.paginaFirma;
      }
      if (this.signType.proveedor === signerProviderConfigs.SAgile.key) {
        body.noRedirectOnEnd = true;
      }
      const meta = {
        ...this.meta,
        fecha: this.manageDate,
        accion: this.processDocument,
        alcanceId: this.stepId.temporalAutorUsuarioId
          || this.stepId.paso.tipoValorResponsableId
      };

      if (this.processDocument === 'foliar') {
        meta.tipoDocId = this.typeNumeration;
        meta.alcanceId = this.stepId.temporalAutorUsuarioId
          || this.stepId.paso.tipoValorResponsableId;
      }
      try {
        const response = await this.manageFileFlow({ body, meta });
        this.loading = false;
        if (this.processDocument === 'foliar') {
          this.folio = response.meta.folio;
        }
        this.$refs.numerateModal.show();
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
    configActiveSigner() {
      if (this.signType && this.signType.proveedor) {
        this.signerProviderConfig = this.signerProviderConfigs[this.signType.proveedor];
        if (this.signerProviderConfig.configureOnSelect) {
          this.signerProviderConfig.configureOnSelect(this.signType, this.signerProviderConfig);
        }
      } else {
        this.signerProviderConfig = {};
      }
    },
  },
  mounted() {
    this.signerProviderConfig = {};
    this.meta = {};
    const [signSelected] = this.userSignConfiguration.userSigns;
    const segPresSign = this.userSignConfiguration.userSigns.find(
      (sign) => sign.proveedor.includes('Segpres')
    );
    if (segPresSign) {
      this.signType = segPresSign;
    } else {
      this.signType = signSelected;
    }
  },
  props: {
    action: { type: String, required: true },
    title: { type: String, required: true },
    process: { type: Boolean, required: false },
    stepId: { type: Object, required: false },
    getSign: Function,
    numPages: Number
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
    'b-modal': VBModal
  },
};
</script>
<style scoped>
.wrap-numeration {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.warning-confirmation {
  background-color: #ff9800;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
}
</style>
